import React, { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Button, Container, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { updateMeetingTaskInJira } from '../../services/jira.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { FormControl, InputLabel, Select, MenuItem, Backdrop, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import "./taskComponents.scss";
import { dropDownMenuProps } from '../../utils/components';
import { openProjectIssueStatuses } from '../../utils/issues';
import { updateMeetingTaskInOpenProject } from '../../services/openProject.service';
import { CDN_MEETING_ATTACHMENT_FOLDER } from '../../services/const';
interface DialogProps {
    isOpen: boolean;
    onClose: ( isMeetingUploaded:boolean) => void;
  }


const UploadMeetingVideoDialog: React.FC<DialogProps> = ({ isOpen, onClose }) => {

	const issueDetails = useSelector((state: RootState) => state.issue);
	const projectState = useSelector((state: RootState) => state.project);
	const userState = useSelector((state: RootState) => state.user);
	const userDetails = userState?.user;
	const projectTypeMenu = projectState.projectTypeMenu;
	const projectType = projectState.projectType;
	
	const [fullScreenLoading, setFullScreenLoading] = useState(false);
	const [taskTransitionList, setTaskTransitionList] = useState<any[]>([]);

	const  initialValues = {
		transitionId: '',
		video: null as File | null,
	};

	const uploadMeetingForJira = async (values: typeof initialValues) =>{
		if(issueDetails?.key){
			try {
				const jiraUserId = userDetails?.jiraDetails?.accountId;
				const formData = new FormData();
				formData.append('File', values.video!);
				formData.append('transitionId', values.transitionId!);
				formData.append('userId', jiraUserId!);
				formData.append('folderName', CDN_MEETING_ATTACHMENT_FOLDER);

				setFullScreenLoading(true);
				const response = await updateMeetingTaskInJira({issueKey:issueDetails?.key,formData});
				
				if(response?.statusCode === 200){
					toast.success('Meeting Upload successful');
					setFullScreenLoading(true);
					formik.resetForm();
					onClose(true);
				}else {
					toast.warning(response?.message || 'Meeting Upload Failled');
				}
			} catch (error) {
				toast.error('Meeting Upload Failled');
			}finally{
				setFullScreenLoading(false);
			}
		}
	};

	const uploadMeetingForOpenProject = async (values: typeof initialValues) =>{
		if(issueDetails?.key){
			try {
				const statusLinkObj = taskTransitionList?.find(taskType => taskType?.id === values?.transitionId);
				const statusLink = statusLinkObj?._links?.self?.href;
				const openProjectUserId = userDetails?.openProjectDetails?.id;
				const issueId = `${issueDetails?.id}`
				const formData = new FormData();
				formData.append('File', values.video!);
				formData.append('status', statusLink);
				formData.append('userId', openProjectUserId!);
				formData.append('folderName', CDN_MEETING_ATTACHMENT_FOLDER);

				setFullScreenLoading(true);
				const response = await updateMeetingTaskInOpenProject({formData,issueId});
				
				if(response?.statusCode === 200){
					toast.success('Meeting Upload successful');
					setFullScreenLoading(true);
					formik.resetForm();
					onClose(true);
				}else {
					toast.warning(response?.message || 'Meeting Upload Failled');
				}
			} catch (error) {
				toast.error('Meeting Upload Failled');
			}finally{
				setFullScreenLoading(false);
			}
		}
	}

	const onSubmit = async (values: typeof initialValues) => {
		switch(projectType){
			case(projectTypeMenu[0]): {
				uploadMeetingForOpenProject(values);
			  break;
			}
			case(projectTypeMenu[2]): {
				uploadMeetingForJira(values)
			  break;
			}
		  }
	};



  const formik = useFormik({
    initialValues,
    onSubmit
  });

	const handleClose = () => {
		formik.resetForm();
		onClose(false);
	}

	const handleDrop = useCallback(
    (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      formik.setFieldValue('video', file);
    },
    [formik]
  );

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      formik.setFieldValue('video', event.target.files[0]);
    }
  };

  const getOpenProjectIssueStatus = async () =>{
    const openProjectTaskStatus = openProjectIssueStatuses;
    setTaskTransitionList(openProjectTaskStatus.elements);
  }
  
  const getJiraIssueStatus = async () =>{
    if(issueDetails?.issueData) {
			const transitions = issueDetails?.issueData?.transitions;
			if(Array.isArray(transitions) && transitions.length){
				setTaskTransitionList(transitions);
			}else {
				setTaskTransitionList([]);
			}
		}else{
			setTaskTransitionList([]);
		}
  }
  const getWaymoreIssueStatus = async () =>{
    setTaskTransitionList([]);
  }

  const getIssueStatus = async() =>{
    if(projectType === projectTypeMenu[0]) {
      await getOpenProjectIssueStatus();
    } else if (projectType === projectTypeMenu[2]) {
      await getJiraIssueStatus();
    }else {
      await getWaymoreIssueStatus();
    }
  }

  useEffect(()=>{
    getIssueStatus();
	// eslint-disable-next-line react-hooks/exhaustive-deps
  },[issueDetails?.key])

  return (
    <Dialog open={isOpen}>
        <DialogTitle>Upload Meeting Video</DialogTitle>
        <DialogContent>
            <Container maxWidth="sm">
            <form onSubmit={formik.handleSubmit}>

						<FormControl fullWidth>
              <InputLabel className='bg-white' id="addtonal-info-transitionId-select-lable">Status</InputLabel>
              <Select
									margin='dense'
                  id="transitionId"
                  labelId='addtonal-info-transitionId-select-lable'
                  name="transitionId"
                  value={formik.values.transitionId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.transitionId && Boolean(formik.errors.transitionId)}
                  MenuProps={dropDownMenuProps}
                >
                  {taskTransitionList?.map((transition:any) => (
                    <MenuItem value={transition?.id}>{transition?.name}</MenuItem>
                  ))}
              </Select>
            </FormControl>

				<div
					onDrop={handleDrop}
					onDragOver={handleDragOver}
					className='dragDrop-container'
					
				>
					<input
						type="file"
						accept="video/*"
						id="video"
						name="video"
						onChange={handleFileChange}
						className='video-input'
					/>
					<TextField
						fullWidth
						variant="outlined"
						margin="normal"
						onClick={() => document.getElementById('video')?.click()}
						inputProps={{ readOnly: true }}
						value={formik.values.video?.name || ''}
						placeholder="Drag & Drop video here, or click to select video"
					/>
				</div>

				<div className='action-button-container' style={{ display: 'flex' , justifyContent: 'space-between'}} >
					<Button disabled={!formik.values.video} type="submit" variant="contained" color="primary">
					Upload
					</Button>
					<Button variant="contained" color="secondary" onClick={handleClose}>
						Cancel
					</Button>
				</div>
            </form>
            </Container>
						<Backdrop open={fullScreenLoading} sx={{zIndex:(theme)=> theme.zIndex.drawer +1}}>
								<CircularProgress />
						</Backdrop>
        </DialogContent>
    </Dialog>
    
  );
};

export default UploadMeetingVideoDialog;
